<template>
	<div data-tour-scope="setting-smtp">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.smtpEmail') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							item-key="item._id"
							data-tour="table"
						>
							<template v-slot:body>
								<!-- telefono: ogni servizio diventa una card con interruttore e configurazione -->
								<tbody v-if="mobileCards" class="smtp-cards">
									<tr v-for="s in servizi" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<span class="d-inline-flex align-center">
														<v-avatar size="24px" tile class="mr-2"><img :src="s.logo" :alt="s.nome" /></v-avatar>
														{{ s.nome }}
													</span>
												</template>
												<template v-slot:actions>
													<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0 pt-0 mr-2" hide-details></v-switch>
													<v-btn small icon color="primary" :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Configura'" @click="extension(s.indice)">
														<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<service-panel
													v-if="checkpresenza(s.indice)"
													:servizio="s"
													:modello="modello(s)"
													:intestazione="false"
													:data-tour="s.indice === 0 ? 'settings' : null"
													@save="saveSetting(s.indice)"
												>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="s in servizi">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(s.indice) }" @click="extension(s.indice)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Configura'" @click.stop="extension(s.indice)">
													<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="s.logo" :alt="s.nome" />
												</v-avatar>
												{{ s.nome }}
											</td>
											<td @click.stop>
												<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
										</tr>
										<tr v-if="checkpresenza(s.indice)" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<service-panel :servizio="s" :modello="modello(s)" :data-tour="s.indice === 0 ? 'settings' : null" @save="saveSetting(s.indice)">
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from './components/ServicePanel.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createSmtpTourSteps, stopSmtpTour } from './smtp-tour';

export default {
	name: 'Framework',
	setup() {
		return { tour: useTour(createSmtpTourSteps(), { onStop: stopSmtpTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			// verifica connessione: verifica le impostazioni salvate
			connectionCheck: { open: false, service: 'smtp' },
			headers: [{ text: '', sortable: false }, { text: 'Servizio', sortable: false }, { text: 'Status', sortable: false }],
			messages: {
				email: [],
				name: [],
				password: [],
			},

			isMobile: false,

			smtp: {
				active: '',
				setting: {
					host: '',
					port: '',
					user: '',
					password: '',
					mittente: '',
					ordini: '',
					secure: true,
				},
				type: 'email',
				service: 'smtp',
			},
			imap: {
				active: '',
				setting: {
					host: '',
					port: '',
					user: '',
					password: '',
					mittente: '',
					secure: true,
				},
				type: 'email',
				service: 'imap',
			},
			dem4: {
				active: false,
				setting: {
					apiKey: '',
				},
				type: 'newsletter',
				service: 'dem4',
			},
			mailchimp: {
				active: false,
				setting: {
					apiKey: '',
					prefix: '',
				},
				type: 'newsletter',
				service: 'mailchimp',
			},
			brevo: {
				active: false,
				setting: {
					apiKey: '',
				},
				type: 'newsletter',
				service: 'brevo',
			},
			getresponse: {
				active: false,
				setting: {
					apiKey: '',
				},
				type: 'newsletter',
				service: 'getresponse',
			},
			activecampaign: {
				active: false,
				setting: {
					apiKey: '',
					endpoint: '',
				},
				type: 'newsletter',
				service: 'activecampaign',
			},
			mailgun: {
				active: false,
				setting: {
					apiKey: '',
					endpoint: '',
				},
				type: 'newsletter',
				service: 'mailgun',
			},
			sendgrid: {
				active: false,
				setting: {
					apiKey: '',
				},
				type: 'newsletter',
				service: 'sendgrid',
			},
			mailup: {
				active: false,
				setting: {
					clientId: '',
					clientSecret: '',
				},
				type: 'newsletter',
				service: 'mailup',
			},
			lists: [],
		};
	},
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},
	async created() {
		this.setPreload(true);
		let promises = [];
		// stesso ordine degli indici di saveSetting: mailup e' il 9
		this.lists = ['smtp', 'imap', 'dem4', 'mailchimp', 'brevo', 'getresponse', 'activecampaign', 'mailgun', 'sendgrid', 'mailup'];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(this.lists));
		await Promise.all(promises);

		this.setPreload(false);

		let smtp = _.find(this.getServices, set => {
			return set.service === 'smtp';
		});
		if (smtp) {
			this.smtp = {
				active: smtp.active,
				setting: {
					host: smtp.setting?.host ? smtp.setting.host : '',
					port: smtp.setting?.port ? smtp.setting.port : '',
					user: smtp.setting?.user ? smtp.setting.user : '',
					password: smtp.setting?.password ? smtp.setting.password : '',
					ordini: smtp.setting?.ordini ? smtp.setting.ordini : '',
					mittente: smtp.setting?.mittente ? smtp.setting.mittente : '',
					secure: smtp.setting?.secure ? smtp.setting.secure : true,
				},
				type: 'email',
				service: 'smtp',
			};
		}

		let imap = _.find(this.getServices, set => {
			return set.service === 'imap';
		});
		if (imap) {
			this.imap = {
				active: imap.active,
				setting: {
					host: imap.setting?.host ? imap.setting.host : '',
					port: imap.setting?.port ? imap.setting.port : '',
					user: imap.setting?.user ? imap.setting.user : '',
					password: imap.setting?.password ? imap.setting.password : '',
					mittente: imap.setting?.mittente ? imap.setting.mittente : '',
					secure: imap.setting?.secure ? imap.setting.secure : true,
				},
				type: 'email',
				service: 'imap',
			};
		}

		let dem4 = _.find(this.getServices, set => {
			return set.service === 'dem4';
		});
		if (dem4) {
			this.dem4 = {
				active: dem4.active,
				setting: {
					apiKey: dem4.setting?.apiKey ? dem4.setting.apiKey : '',
				},
				type: 'newsletter',
				service: 'dem4',
			};
		}
		let mailchimp = _.find(this.getServices, set => {
			return set.service === 'mailchimp';
		});
		if (mailchimp) {
			this.mailchimp = {
				active: mailchimp.active,
				setting: {
					apiKey: mailchimp.setting?.apiKey ? mailchimp.setting.apiKey : '',
					prefix: mailchimp.setting?.prefix ? mailchimp.setting.prefix : '',
				},
				type: 'newsletter',
				service: 'mailchimp',
			};
		}

		let brevo = _.find(this.getServices, set => {
			return set.service === 'brevo';
		});
		if (brevo) {
			this.brevo = {
				active: brevo.active,
				setting: {
					apiKey: brevo.setting?.apiKey ? brevo.setting.apiKey : '',
				},
				type: 'newsletter',
				service: 'brevo',
			};
		}
		let getresponse = _.find(this.getServices, set => {
			return set.service === 'getresponse';
		});
		if (getresponse) {
			this.getresponse = {
				active: getresponse.active,
				setting: {
					apiKey: getresponse.setting?.apiKey ? getresponse.setting.apiKey : '',
				},
				type: 'newsletter',
				service: 'getresponse',
			};
		}
		let activecampaign = _.find(this.getServices, set => {
			return set.service === 'activecampaign';
		});
		if (activecampaign) {
			this.activecampaign = {
				active: activecampaign.active,
				setting: {
					apiKey: activecampaign.setting?.apiKey ? activecampaign.setting.apiKey : '',
					endpoint: activecampaign.setting?.endpoint ? activecampaign.setting.endpoint : '',
				},
				type: 'newsletter',
				service: 'activecampaign',
			};
		}
		let mailgun = _.find(this.getServices, set => {
			return set.service === 'mailgun';
		});
		if (mailgun) {
			this.mailgun = {
				active: mailgun.active,
				setting: {
					apiKey: mailgun.setting?.apiKey ? mailgun.setting.apiKey : '',
					endpoint: mailgun.setting?.endpoint ? mailgun.setting.endpoint : '',
				},
				type: 'newsletter',
				service: 'mailgun',
			};
		}
		let sendgrid = _.find(this.getServices, set => {
			return set.service === 'sendgrid';
		});
		if (sendgrid) {
			this.sendgrid = {
				active: sendgrid.active,
				setting: {
					apiKey: sendgrid.setting?.apiKey ? sendgrid.setting.apiKey : '',
				},
				type: 'newsletter',
				service: 'sendgrid',
			};
		}
		let mailup = _.find(this.getServices, set => {
			return set.service === 'mailup';
		});
		if (mailup) {
			this.mailup = {
				active: mailup.active,
				setting: {
					clientId: mailup.setting?.clientId ? mailup.setting.clientId : '',
					clientSecret: mailup.setting?.clientSecret ? mailup.setting.clientSecret : '',
				},
				type: 'newsletter',
				service: 'mailup',
			};
		}
	},

	components: {
		TourOverlay,
		KeyValueCard,
		ServicePanel,
		MarketplaceConnectionCheck,
	},
	computed: {
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',

			getServices: 'services/getServices',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// servizi mostrati come card: stesso indice di saveSetting/extension e stessi campi della tabella
		// righe della tabella: indice = argomento di saveSetting/extension, key = oggetto in data
		servizi() {
			const logo = file => require('@/assets/images/newletter/' + file);
			const ssl = [
				{ text: 'Sì', value: true },
				{ text: 'No', value: false },
			];
			const chiave = [{ key: 'apiKey', label: 'API key', tipo: 'password' }];
			return [
				{
					key: 'smtp',
					connessione: 'smtp',
					indice: 0,
					nome: 'Smtp',
					logo: logo('mail.svg'),
					campi: [
						{ key: 'host', label: 'Host' },
						{ key: 'port', label: 'Porta' },
						{ key: 'user', label: 'Utente' },
						{ key: 'password', label: 'Password', tipo: 'password' },
						{ key: 'secure', label: 'SSL', tipo: 'select', items: ssl },
						{ key: 'mittente', label: 'Mittente' },
						{ key: 'ordini', label: 'Email ricezione ordini', pieno: true },
					],
				},
				{
					key: 'imap',
					connessione: 'imap',
					indice: 1,
					nome: 'Imap',
					logo: logo('mail.svg'),
					campi: [
						{ key: 'host', label: 'Host' },
						{ key: 'port', label: 'Porta' },
						{ key: 'user', label: 'Utente' },
						{ key: 'password', label: 'Password', tipo: 'password' },
						{ key: 'secure', label: 'SSL', tipo: 'select', items: ssl },
						{ key: 'mittente', label: 'Mittente' },
					],
				},
				{ key: 'dem4', connessione: 'dem4', indice: 2, nome: '4Dem', logo: logo('4dem.svg'), campi: chiave },
				{ key: 'mailchimp', connessione: 'mailchimp', indice: 3, nome: 'Mail Chimp', logo: logo('mailchimp.svg'), campi: [...chiave, { key: 'prefix', label: 'Prefix' }] },
				{ key: 'brevo', connessione: 'brevo', indice: 4, nome: 'Brevo', logo: logo('brevo.svg'), campi: chiave },
				{ key: 'getresponse', connessione: 'getresponse', indice: 5, nome: 'GetResponse', logo: logo('getresponse.svg'), campi: chiave },
				{ key: 'activecampaign', connessione: 'activecampaign', indice: 6, nome: 'Active Campaign', logo: logo('activecampaign.svg'), campi: [...chiave, { key: 'endpoint', label: 'Endpoint' }] },
				{ key: 'mailgun', connessione: 'mailgun', indice: 7, nome: 'Mailgun', logo: logo('mailgun.svg'), campi: [...chiave, { key: 'endpoint', label: 'Endpoint' }] },
				{ key: 'sendgrid', connessione: 'sendgrid', indice: 8, nome: 'Sendgrid', logo: logo('sendgrid.svg'), campi: chiave },
				{
					key: 'mailup',
					connessione: 'mailup',
					indice: 9,
					nome: 'MailUp',
					logo: logo('mailup.svg'),
					campi: [
						{ key: 'clientId', label: 'Client ID' },
						{ key: 'clientSecret', label: 'Client Secret', tipo: 'password' },
					],
				},
			];
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
		}),

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		async saveSetting(item) {
			let payload;
			const elements = JSON.parse(JSON.stringify(this.lists));

			elements.splice(0, 2);
			const checkActive = [];
			for (let el of elements) {
				if (this[el].active) {
					checkActive.push(el);
				}
			}
			if (checkActive.length > 1) {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Devi selezionare un servizio alla volta';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;

				await this.delay(1000);
				this[this.lists[item]].active = false;

				return;
			}

			switch (item) {
				case 0:
					payload = this.smtp;
					this.setPreload(true);
					break;
				case 1:
					payload = this.imap;
					this.setPreload(true);
					break;
				case 2:
					payload = this.dem4;
					this.setPreload(true);
					break;
				case 3:
					payload = this.mailchimp;
					this.setPreload(true);
					break;
				case 4:
					payload = this.brevo;
					this.setPreload(true);
					break;
				case 5:
					payload = this.getresponse;
					this.setPreload(true);
					break;
				case 6:
					payload = this.activecampaign;
					this.setPreload(true);
					break;
				case 7:
					payload = this.mailgun;
					this.setPreload(true);
					break;
				case 8:
					payload = this.sendgrid;
					this.setPreload(true);
					break;
				case 9:
					payload = this.mailup;
					this.setPreload(true);
					break;
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		// oggetto in data del servizio: created() lo sostituisce, quindi va letto ogni volta
		modello(servizio) {
			return this[servizio.key];
		},
	},
};
</script>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.smtp-cards,
.smtp-cards tr {
	display: block;
	width: 100%;
}
.smtp-cards tr,
.smtp-cards tr:hover {
	background: transparent !important;
}
.smtp-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.smtp-cards tr:first-child td {
	padding-top: 12px !important;
}
.smtp-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.smtp-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
